import React, { Component } from 'react';
import {Link}from 'react-router-dom';



import imageSupplier01 from './Logos_Lieferanten/msmarking.png';
import imageSupplier02 from './Logos_Lieferanten/steidle.png';
import imageSupplier03 from './Logos_Lieferanten/aeroLift.jpg';
import imageSupplier04 from './Logos_Lieferanten/Gressel.png';
import imageSupplier05 from './Logos_Lieferanten/sllaser.png';
import imageSupplier06 from './Logos_Lieferanten/nordLock.png';
import imageSupplier07 from './Logos_Lieferanten/fetzer.png';



import { Grid, Row, Col, Breadcrumb} from 'react-bootstrap';

class Zub extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="BCMain">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/Suppliers">Übersicht</Breadcrumb.Item>
            <Breadcrumb.Item active>Zubehör</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <br/>
        <Grid>


            {/* Steidle */}

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/Steidle"><img className="supplierImagesOverview" src={imageSupplier02} alt="Steidle" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/Steidle">
              <h3>Sprühsysteme und Minimalmengen-Kühlschmierung</h3>
              <h4 className="verticalAlign">Die Steidle GmbH ist Pionier und Wegbereiter der Technik, die sich heute unter der Bezeichnung Minimalmengen-Kühlschmierung (MMKS) als zukunftsweisende Strategie für die Metallbearbeitung etabliert hat.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/Steidle">
              <h4 className="verticalAlign">Sprühsysteme und Minimalmengen-Kühlschmierung</h4>
            </Link>
            </Col>
          </Row>

          <hr/>
          {/* Fetzer */}

        <Row className="show-grid">
          <Col xs={12}  sm={3}>
              <Link to="/Suppliers/fetzer"><img className="supplierImagesOverview" src={imageSupplier07} alt="Steidle" width="100%"/></Link>
          </Col>
          <Col xsHidden  sm={9} className="supplierOverviewDesc">
            <Link to="/Suppliers/fetzer">
            <h3>Lager- und Logistiklösungen</h3>
            <h4 className="verticalAlign">Das Unternehmen Fetzer bietet die Planung, Konstruktion, Fertigung, Service und Montage von Lager- und Logistiklösungen aus einer Hand an. </h4>
          </Link>
          </Col>
          <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
            <Link to="/Suppliers/fetzer">
            <h4 className="verticalAlign">Lager- und Logistiklösungen</h4>
          </Link>
          </Col>
        </Row>

          {/* Aerolift */}
          <hr/>

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/Aerolift"><img className="supplierImagesOverview" src={imageSupplier03} alt="Logo Aerolift" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/Aerolift">
              <h3>Heben mit Vakuumhebetechnik </h3>
              <h4 className="verticalAlign">AERO-LIFT ist Spezialist für Vakuumhebetechnik. Eine breite Produktpalette, Individuallösungen, hohe Qualität "Made in Germany" und guter Service zeichnen das mittelständische Unternehmen von der Schwäbischen Alb aus. </h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/Aerolift">
              <h4 className="verticalAlign">Heben mit Vakuumhebetechnik </h4>
            </Link>
            </Col>
          </Row>


            {/* GRESSEL */}
            <hr/>

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/Gressel"><img className="supplierImagesOverview" src={imageSupplier04} alt="Logo Gressel" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/Gressel">
              <h3>Spanntechnik der Zukunft</h3>
              <h4 className="verticalAlign">Von der mechanischen Werkstatt zum Spezialisten für die effiziente Werkstück-Spanntechnik - das Schweizer Unternehmen GRESSEL AG befasst sich seit über 90 Jahren mit der Metallbearbeitung. Mit dem 1965 lancierten Hochdruckspanner gelang der Zugang zur industriellen Fertigung und in der Folge sorgte das Unternehmen in der Branche "spanntechnisch" immer wieder für Furore. </h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/Gressel">
              <h4 className="verticalAlign">Spanntechnik der Zukunft</h4>
            </Link>
            </Col>
          </Row>

            {/* SL Laser */}
            <hr/>

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/SLLaser"><img className="supplierImagesOverview" src={imageSupplier05} alt="Logo SL Laser" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/SLLaser">
              <h3>Positionierung mit Laserlicht</h3>
              <h4 className="verticalAlign">Die Fa. SL-Laser GmbH entwickelt und produziert seit 1988 Laser-Projektionssysteme zum exakten Positionieren und Ausrichten von Maschinen und Werkstücken. Nach den Anfängen im Holz und CNC-Bereich ist SL-Laser heute ebenso ein Begriff in der Flugzeugindustrie, bei der Fertigung von Betonfertigteilen und bei der Montage und Vermessung in vielen anderen Bereichen.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/SLLaser">
              <h4 className="verticalAlign">Positionierung mit Laserlicht</h4>
            </Link>
            </Col>
          </Row>

            {/* MS-Marking */}
            <hr/>

            <Row className="show-grid">
              <Col xs={12}  sm={3}>
                  <Link to="/Suppliers/MSMarking"><img className="supplierImagesOverview" src={imageSupplier01} alt="MS-Marking"  width="100%" height="100%"/></Link>
              </Col>
              <Col xsHidden  sm={9} className="supplierOverviewDesc">
                <Link to="/Suppliers/MSMarking">
                <h3>Markiersysteme für den Produktionsprozess</h3>
                <h4 className="verticalAlign">MS-Marking ist Lieferant von Systemen und Technologien zur direkten und dauerhaften Kennzeichnung von Teilen und Komponenten im Produktionsprozess. Mit unserem Partner und Hersteller entwickeln und produzieren wir komplette Lösungen zum Markieren von Teilen in  automatischen Produktionslinien, sowie tragbaren Maschinen zum Kennzeichnen von Grossbauteilen. Ein besonderes Highlight sind Tiefenprägungen für die Kennzeichnung von Fahrgestellnummern, die durch den Einsatz gesteuerter Impulstechnik ermöglicht wird.</h4>
              </Link>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
                <Link to="/Suppliers/MSMarking">
                <h4 className="verticalAlign">Markiersysteme für den Produktionsprozess </h4>
              </Link>
              </Col>
            </Row>

            {/* Nord Lock */}
            <hr/>

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/NordLock"><img className="supplierImagesOverview" src={imageSupplier06} alt="Logo Nord-Lock" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/NordLock">
              <h3>Spannelemente mit Vielfachschrauben</h3>
              <h4 className="verticalAlign"> Superbolt Spannelemente bieten Ihnen einfache und kostengünstige Spannverfahren für großformatige Bolzen. Ihre Verbindungen können mit hoher Genauigkeit angezogen werden, ohne dass besondere Fachkenntnisse oder schweres Werkzeug benötigt wird.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/NordLock">
              <h4 className="verticalAlign">Spannelemente mit Vielfachschrauben</h4>
            </Link>
            </Col>
          </Row>

            {/* esmatec
            <hr/>

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/esmatec"><img className="supplierImagesOverview" src={imageSupplier07} alt="esmatec" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/esmatec">
              <h3>Kantenfräsen, die günstige Alternative</h3>
              <h4 className="verticalAlign">Die esmatec GmbH ist ein im Jahre 1989 gegründetes Unternehmen. Neben Eigenentwicklungen im Bereich der Kantenfräsmaschinen beschäftigt sich esmatec mit der Verbesserung qualitativ hochwertiger Lohnfertigungen durch innovative Lösungen.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/esmatec">
              <h4 className="verticalAlign">Kantenfräsen, die günstige Alternative </h4>
            </Link>
            </Col>
          </Row>
          */}
          <br/><br/><br/>


        </Grid>
        <br/>
        <br/>

      </div>
    );
  }
}

export default Zub;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/zub.js